import React, { Component } from "react";
import styled from "styled-components";
import { Query } from "@apollo/client/react/components";
import Error from "../components/Error";
import ProductQuery from "../apollo/queries/ProductQuery";
import LoadingSpinner from "../components/LoadingSpinner";
import ProductDescription from "../components/ProductDescription/ProductDescription";
import { withRouter } from "../withRouter";
const Container = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  margin: 3rem auto;
  min-height: 100vh;
  position: relative;
  @media screen and (min-width: 768px) {
    flex-direction: row;
    align-items: unset;
  }
`;

class ProductDescriptionPage extends Component {
  constructor() {
    super();
    this.state = { selectedImage: "" };
  }
  render() {
    return (
      <Container>
        <Query
          fetchPolicy="no-cache"
          query={ProductQuery}
          variables={{ id: this.props.params.productName.toLowerCase() }}
        >
          {({ loading, error, data }) => {
            if (loading) return <LoadingSpinner />;
            if (data.product === null) return <Error type="Product" />;
            if (error) return <Error type="Server" />;
            return <ProductDescription productDetails={data.product} />;
          }}
        </Query>
      </Container>
    );
  }
}
export default withRouter(ProductDescriptionPage);
